"use client";
import React from "react";
import { Empty, Button, Flex, Typography } from "antd";
import Link from "next/link";

const { Title, Paragraph } = Typography;

function EmptySection({ type = "empty" }) {
  const isNotFound = type === "not-found";
  return (
    <Flex
      vertical
      align="center"
      justify="center"
      style={{
        minHeight: "70vh",
        padding: "48px 24px",
        textAlign: "center",
      }}
    >
      <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={false} />

      <Title level={3}>
        {isNotFound ? "Page Not Found" : "Content Coming Soon"}
      </Title>

      <Paragraph>
        {isNotFound
          ? "The page you're looking for doesn't exist."
          : "This page exists, but no content has been published yet."}
      </Paragraph>

      <Link href="/">
        <Button type="primary" size="large">
          Back to Home
        </Button>
      </Link>
    </Flex>
  );
}

export default EmptySection;
